module.exports = ['contactDetailUtils', contactDetailUtils => {
  'use strict';
  return (phone) => {
    return contactDetailUtils.formatPhoneNumber(phone, true);
  };
}];
